import type { TimeTrackingExtendedType } from "~/modules/timeTracking/api/timeTracking/timeTrackingTypes.ts";
import { TimeTrackingTypeId } from "~/modules/timeTracking/api/timeTrackingType/timeTrackingTypeTypes.ts";
import type {
	TimeTrackingBarThemes,
} from "~/modules/timeTracking/components/components/Day/components/TimeTrackingBar/timeTrackingBarVariants.ts";

export function getTimeTrackingBarTheme(timeTracking: TimeTrackingExtendedType): {
	theme: TimeTrackingBarThemes;
	title?: string;
} {
	switch (timeTracking.timeTrackingTypeId) {
		case TimeTrackingTypeId.Project:
			return { theme: timeTracking.isBillable ? "project" : "projectNotBillable", title: timeTracking.projectTitle };
		case TimeTrackingTypeId.Internal:
			return { theme: "internal", title: "Intern" };
		case TimeTrackingTypeId.Sales:
			return { theme: "sales", title: "Sales" };
		case TimeTrackingTypeId.PartTime:
			return { theme: "partTime", title: "Teilzeit" };
		default:
			return { theme: "default" };
	}
}
